import { Grid, Typography } from '@mui/material'
import React from 'react'

export const EventOverlapError: React.FC = () => {
  return (
    <Grid container item xs={12} style={{ marginBottom: 20 }}>
      <Typography variant="h4">
        Event overlap is not allowed.
      </Typography>
    </Grid>
  )
}
